<template>
  <RevButton v-if="!error" :disabled="!url" :to="url" variant="primary">
    {{ ctaLabel }}
  </RevButton>
</template>

<script setup lang="ts">
import { RevButton } from '@ds/components/Button'

import { useMilitaryDiscountUrl } from './useMilitaryDiscountUrl'

defineProps<{ ctaLabel: string }>()

const { url, error } = useMilitaryDiscountUrl()
</script>
